import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Typography } from '../../../DesignSystem';
import YatHandLoader from '../../../loaders/YatHandLoader';
import '../ArtifactMintPanel.scss';

interface LoadingProps {
    hideCopy?: boolean;
}

export const Loading = ({ hideCopy }: LoadingProps) => {
    const { t } = useTranslation(['nft', 'artifacts']);
    const [text, setText] = useState<string>(t('minting_loading_text'));

    useEffect(() => {
        const timer = setTimeout(
            function () {
                setText(t('minting_loading_overtime_text'));
            },
            2 * 20 * 1000,
        ); // 2 minutes

        return () => {
            clearTimeout(timer);
        };
    }, [t]);

    return (
        <div className="yat-artifact-sidebar__step">
            <div className="yat-artifact-sidebar__flex-item">
                <div className="yat-artifact-sidebar__hand-loader">
                    <YatHandLoader />
                </div>

                {!hideCopy && (
                    <>
                        <Typography type="headline" size={20} classes={['yat-artifact-sidebar__title']}>
                            {t('minting_loading_title', { item: t('artifacts:artifact') })}
                        </Typography>

                        <Typography type="paragraph" size={16} classes={['yat-artifact-sidebar__text']}>
                            <span dangerouslySetInnerHTML={{ __html: text }} />
                        </Typography>
                    </>
                )}
            </div>
        </div>
    );
};
